/* eslint-disable react/destructuring-assignment */
import React, { SVGProps } from 'react';

function CheckIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="17" height="12" viewBox="0 0 17 12" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M5.69099 12C5.55365 12 5.42489 11.9743 5.30472 11.9227C5.18455 11.8712 5.07296 11.794 4.96996 11.691L0.309013 7.03004C0.103004 6.82404 0 6.57511 0 6.28326C0 5.99142 0.103004 5.74249 0.309013 5.53648C0.515021 5.33047 0.759657 5.22747 1.04292 5.22747C1.32618 5.22747 1.57082 5.33047 1.77682 5.53648L5.69099 9.45064L14.8584 0.309013C15.0472 0.103004 15.2833 0 15.5665 0C15.8498 0 16.0944 0.103004 16.3004 0.309013C16.5064 0.515021 16.6094 0.763949 16.6094 1.05579C16.6094 1.34764 16.5064 1.58798 16.3004 1.77682L6.41202 11.691C6.30901 11.794 6.19742 11.8712 6.07725 11.9227C5.95708 11.9743 5.82833 12 5.69099 12Z" fill={props.fill || '#9B9B9B'} />
    </svg>
  );
}

export default CheckIcon;
